<section class="pt-2 ">
  <div class="">
    <div class="row align-items-center mx-0 p-1">
      <div class="col-lg-6 col-md-6 col-sm-6 col-6">
        <h6>
          {{ isFormView ? 'Registrar detalle de suspensión' : 'Detalle de suspensión' }}
        </h6>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-6 col-6 d-flex justify-content-end">
        <app-custom-modal #rentalStock [label]="'Nuevo Detalle'" [header]="'Selección de artículos en c.costos'"
          [children]="component" [inputs$]="inputsForRentalStock$" [output$]="output$" [disabled]="disabledDetail"
          (selectedItems)="handleSelectedItems($event)" hidden></app-custom-modal>
        <app-custom-button tom-button [label]="'Nuevo Detalle'" [severity]="'success'" [disabled]="disabledButton"
          (onClick)="openModal()" [width]="'6.5rem'"></app-custom-button>
      </div>
    </div>
    <div class="row mx-0" [hidden]="!isFormView">
      <div class="col-lg-12 col-md-12 col-sm-12 col-12 border">
        <app-register-suspension-detail [suspensionDetailContract]="suspensionDetail"
          [suspensionContract]="suspensionModel" [disabled]="disabledDetail" [suspensionDetails]="suspensionDetails"
          (updateListDetail)="getSuspensionDetailsBySuspension()" (isFormView)="getFormView($event)">
        </app-register-suspension-detail>
      </div>
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-12 border">
      <app-custom-table [headers]="detailHeader" [data]="detailData" [actions]="tableActions"
        [showCheckbox]=" !disabledButton" [checkBoxAction]="checkboxActions"
        [clearSelectionTrigger]="clearSelectionTrigger" (onRecoverData)="getSuspensionDetailsBySuspension()"
        (onPageChange)="onPageChange($event)" (onAction)="onAction($event)">
      </app-custom-table>
    </div>
  </div>
</section>